var quickaddButton = document.querySelectorAll("[data-card-quickadd]");
var quickAddMessageTitle = document.querySelector("[data-quickadd-message-title]");

quickaddButton.forEach((button) => {
    button.addEventListener("click", () => {
        button.disabled = false;
        var id = parseInt(button.dataset.cardQuickadd);

        let formData = {
            "id": id,
            "quantity": 1
        };

        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
        .then(() => {
            button.disabled = false;
        })
        .catch((err) => {
            button.disabled = false;
            console.error("Error: ", err);
        });
    });
});



// Close quickadd popup
var quickAddClose = document.querySelectorAll("[data-quickadd-close]");
quickAddClose.forEach((close) => {
    close.addEventListener("click", () => {
        console.log("close");
        document.querySelector("[data-quickadd-popup]").style.display = "none";
    })
});

var quickAddButtons = document.querySelectorAll("[data-quickadd-button]");
quickAddButtons.forEach((button) => {
    button.addEventListener("click", (event) => {
        event.preventDefault();

        // if (window.ReChargeWidget == undefined) return false;
    
        if (window.ReChargeWidget != undefined) {
            // Remove previous widget
            var widgetsRecharge = document.querySelectorAll(".quickadd [data-widget-container-wrapper]");
            widgetsRecharge.forEach((widget) => {
                widget.remove();
            })   
        }
        document.querySelector("[data-rc-informations]").innerHTML = "";

        // Get dataset from button
        var data = JSON.parse(button.dataset.quickaddButton);
        var dataGTM = JSON.parse(button.dataset.quickaddButtonGtm);
        var dataAddGTM = JSON.parse(button.dataset.quickaddButtonAddGtm);

        // Replace popup informations
        var img = document.querySelector("[data-quickadd-image]");
        img.src = data.image;

        var title = document.querySelector("[data-quickadd-title]");
        title.innerHTML = data.title;
        
        var subtitle = document.querySelector("[data-quickadd-subtitle]");
        subtitle.innerHTML = data.subtitle;
        
        var select = document.querySelector("[data-quickadd-id]");
        select.form = data.id;
        
        var input = document.querySelector("[data-quickadd-variant-id]");
        input.value = data.variantId;

        let targetTags = document.querySelector('#product-form-recharge button.btn--add-to-cart span');
        if(dataAddGTM[0].item_tags.includes('preco')){
            targetTags.textContent = window.variantStrings.preOrder;
        }else{
            targetTags.textContent = window.variantStrings.addToCart;
        }
        
        var item_name = document.querySelector("[data-item_name]");
        item_name.setAttribute('data-item_name', dataAddGTM[0].item_name);        
        var item_id = document.querySelector("[data-item_id]");
        item_id.setAttribute('data-item_id', dataAddGTM[0].item_id);
        var item_barcode = document.querySelector("[data-item_barcode]");
        item_barcode.setAttribute('data-item_barcode', dataAddGTM[0].item_barcode);        
        var item_category = document.querySelector("[data-item_category]");
        item_category.setAttribute('data-item_category', dataAddGTM[0].item_category);
        var item_category2 = document.querySelector("[data-item_category2]");
        item_category2.setAttribute('data-item_category2', dataAddGTM[0].item_category2);
        var item_selection = document.querySelector("[data-item_selection]");
        item_selection.setAttribute('data-item_selection', dataAddGTM[0].item_selection);
        var pack = document.querySelector("[data-pack]");
        pack.setAttribute('data-pack', dataAddGTM[0].pack);
        var product_related1 = document.querySelector("[data-product_related1]");
        product_related1.setAttribute('data-product_related1', dataAddGTM[0].product_related1);
        var product_related2 = document.querySelector("[data-product_related2]");
        product_related2.setAttribute('data-product_related2', dataAddGTM[0].product_related2);
        var price = document.querySelector("[data-price]");
        price.setAttribute('data-price', dataAddGTM[0].price);
        var currency = document.querySelector("[data-gtm-currency]");
        currency.setAttribute('data-gtm-currency', dataAddGTM[0].currency);
        var discount = document.querySelector("[data-discount]");
        discount.setAttribute('data-discount', dataAddGTM[0].discount);
        
        var price = document.querySelector("[data-quickadd-price]");
        if (window.ReChargeWidget != undefined) {
            price.innerHTML = (data.price / 100).toFixed(2) + "€";
        } else {            
            let price_with_currency = Shopify.formatMoney(data.price, "amount_with_comma_separator");
            price.innerHTML = price_with_currency + "€";
        }

        var url = document.querySelector("[data-quickadd-url]");
        url.href = data.url + "?quick_access";
        url.setAttribute('data-gtm-select-item', JSON.stringify(dataGTM));

        var evt = new CustomEvent("gtmViewSelectList", {'detail': dataGTM});
        window.dispatchEvent(evt);
        
        var scalapay = document.querySelector("[data-price-scalapay]");
        if (scalapay != undefined) {
            var scalapayPrice = (data.price / 100 / 3).toFixed(2);
            scalapay.innerHTML = scalapay.innerHTML.replace("[price]", scalapayPrice.replace(".", ",") + "€");
        }

        document.querySelector("[data-quickadd-compare-at-price]").innerHTML = "";
        if (data.compare_at_price != undefined) {
            var comparePrice = document.querySelector("[data-quickadd-compare-at-price]");
            comparePrice.innerHTML = (data.compare_at_price / 100).toFixed(2) + " EUR";
        }

        // Show quickadd popup
        document.querySelector("[data-quickadd-popup]").style.display = "block";
        setTimeout(() => {
            window.dispatchEvent(new Event('resize'));
        },100)

        if (window.ReChargeWidget != undefined) {
            // Reload recharge
            var id = data.id;
            window.ReChargeWidget.createWidget({ productId: id, selectors: { price: ['.my-price'] } });
            changeRCFormQuickview(data);
        }

    })
});

function changeRCFormQuickview(data) {
  setTimeout(() => {
    updateDiscountLabel();
    moveInformationsQuickview(data);
    allContainerClickable();
  }, 500);
}

function updateDiscountLabel() {
  var labelsDiscount = document.querySelectorAll("[data-label-discount]");
    
  labelsDiscount.forEach((label) => {
    var oldLabel = label.innerHTML;
    label.innerHTML = oldLabel;
  });
}

function allContainerClickable() {
    var rcOption = document.querySelectorAll(".rc-option");

    rcOption.forEach((option) => {
        option.addEventListener("click", (el) => {
            if (document.querySelector(".product__scalapay-text") != undefined) {
                if (option.hasAttribute('data-option-subsave')) {
                    document.querySelector(".product__scalapay-text").classList.add("not-active");
                } else {
                    document.querySelector(".product__scalapay-text").classList.remove("not-active");
                }
            }
            var radioLabel = el.target.querySelector(".rc-radio__label");
            if (radioLabel != null && radioLabel != undefined) {
                radioLabel.click();
            }
        })
    })
}

async function moveInformationsQuickview(data) {
    // var sellingPlanLabel = document.querySelector(".rc-selling-plans__label");
    // var sellingPlanLabelContainer = document.querySelector("[data-rc-commitment]");

    // if (sellingPlanLabel != undefined && sellingPlanLabelContainer != undefined)
    //     sellingPlanLabelContainer.appendChild(sellingPlanLabel.childNodes[0]);

    // var rcPopup = document.querySelector(".rc_popup");
    // var rcPopupLabel = document.querySelector(".rc_popup__label");
    // var rcPopupContainer = document.querySelector("[data-rc-more]");
    
    // if (rcPopupLabel != undefined)
    //     rcPopupLabel.innerHTML = "En savoir +";

    // if (rcPopup != undefined && rcPopupContainer != undefined)
    //     rcPopupContainer.appendChild(rcPopup.childNodes[0]);

    if (document.querySelector("[data-label-text-subsave]") != undefined) {
        getProductTemplate(data.handle);
        document.querySelector("[data-label-text-subsave]").innerHTML = "S'abonner & économiser";
    }



}

async function getProductTemplate(handle, index) {
    await fetch('/products/' + handle + '?section_id=rc_product_infos')
    .then(response => response.text())
    .then(function(data) {
        // Convert the HTML string into a document object
        var parser = new DOMParser();
        var doc = parser.parseFromString(data, 'text/html');
        if (doc.querySelector('[data-rc-informations]') != null) {
            var rcInfos = doc.querySelector('[data-rc-informations]').outerHTML
            var sellingPlanContainer = document.querySelector("[data-selector-subsave]");
            if (rcInfos != undefined && sellingPlanContainer != undefined)
                sellingPlanContainer.insertAdjacentHTML('beforeend', rcInfos);
        }
    });
}